
import { defineComponent, ref } from "vue";
import UserNewArticles from "~/components/UserAccounts/UserNewArticles.vue";
import UserCorporateLayout from "~/components/UserAccounts/UserCorporateLayout.vue";

export default defineComponent({
  name: "UserNewArticlesPage",
  components: {
    UserCorporateLayout,
    UserNewArticles
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    },
    reader: {
      type: Boolean,
      require: false,
      default: false
    },
    favedArticleIds: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  setup() {
    const loading = ref(true);
    return {
      loading,
    };
  }
});
